import { Button } from "antd";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import BreadCrumb from "../../Components/BreadCrumb/BreadCrumb";
import Layout from "../../Components/Layout/Layout";
import Loader from "../../Components/Loader/Loader";
import styles from "./ProductRecalls.module.scss";
import no_recalls from "./images/no_recalls.svg";
import recalls_desktop from "./images/recalls_desktop.png";
import recalls_mobile from "./images/recalls_mobile.jpeg";

const ProductRecalls = () => {
    const [recalls, setRecalls] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    // mock api call
    useEffect(() => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            setError(false);
            setRecalls([]);
        }, 500);
    }, []);

    return (
        <Layout title="Product Recalls and Safety Notice">
            <div className="container">
                <BreadCrumb
                    list={[
                        { name: "Home", link: "/" },
                        { name: "Recalls & Alerts", link: "/product-recalls" },
                    ]}
                />

                <picture>
                    <source media="(min-width:768px)" srcset={recalls_desktop} className="img-fluid" />
                    <source media="(min-width:576px)" srcset={recalls_mobile} className="img-fluid" />
                    <img src={recalls_mobile} alt="Flowers" className="img-fluid" />
                </picture>

                <div className={styles.header}>
                    <h3 className="text-primary fs-2 fw-bold text-center text-md-start">Recalls & Alerts</h3>
                    <p>
                        At Desi Fresh, we prioritize the well-being and safety of our valued customers and members. Our unwavering
                        commitment extends to ensuring that all the products we offer are not only compliant but also safe for consumption.
                        To achieve this, we rely on a dedicated team of health and wellness experts, product safety specialists, and food
                        safety professionals.
                    </p>

                    <p>
                        In the rare event of a product recall (mislabeling, food fraud,
                        https://corporate.aldi.us/en/newsroom/product-recalls/product safety etc.), we take immediate action. Swiftly, we
                        prevent the sale of the affected item and promptly remove it from our suppl stores and clubs. Our proactive approach
                        to handling recalls underscores our dedication to maintaining the highest standards of safety and quality in
                        everything we offer to our esteemed customers.
                    </p>
                </div>

                <div className={styles.body}>
                    {loading && <Loader height={"50vh"} />}

                    {!loading && error && (
                        <div className={`alert alert-danger ${styles.data_error}`}>Error Fetching Data. Please try again later.</div>
                    )}

                    {!loading && !error && recalls.length === 0 && (
                        <div className="d-flex flex-column align-items-center justify-content-center w-100 my-5 gap-3">
                            <img src={no_recalls} alt="no_recalls" className={`img-fluid ${styles.no_data_img}`} />
                            <h2 className="mb-0 fw-bold">No Recalls & Alerts</h2>
                            <p className="mb-0">Browse products and start order.</p>
                            <Link to="/">
                                <Button type="primary" className="px-5">
                                    Start Shopping
                                </Button>
                            </Link>
                        </div>
                    )}
                    {!loading && !error && recalls.length > 0 && (
                        <div className="my-4">
                            <h3 className="text-primary fw-bold text-center text-lg-start fs-1">{new Date().getFullYear()}</h3>
                            <div className="d-flex flex-column gap-3">
                                {recalls.map((recall, index) => (
                                    <div key={index}>
                                        <p className="mb-0 fw-bold">{recall.date}</p>
                                        <a
                                            href={recall.link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-primary text-decoration-underline "
                                        >
                                            {recall.title}
                                        </a>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </Layout>
    );
};

export default ProductRecalls;
